import { ResourceType } from "~/business";
import { XResourceWithAmount } from "./XResourceWithAmount";
import { XSolarisSvg } from "./svg";

export const XOpponentSolaris = ({
  personalAmount,
  width,
}: {
  personalAmount: number;
  opponentAmount: number;
  width: number;
}) => {
  const smallSolarisSize = width / 2;
  return (
    <div style={{ width: width + smallSolarisSize }}>
      <div style={{ width }}>
        <XResourceWithAmount
          amount={personalAmount}
          type={ResourceType.Solaris}
          variant="compact"
          width={width}
        />
        <XSolarisSvg
          width={smallSolarisSize}
          style={{ position: "absolute", right: -smallSolarisSize / 2, top: 0 }}
        />
        <XSolarisSvg
          width={smallSolarisSize}
          style={{
            position: "absolute",
            right: -smallSolarisSize,
            top: (width - smallSolarisSize) / 2,
          }}
        />
        <XSolarisSvg
          width={smallSolarisSize}
          style={{
            position: "absolute",
            right: -smallSolarisSize / 2,
            bottom: 0,
          }}
        />
      </div>
    </div>
  );
};
